import { atom } from "recoil";
import { IFile } from "./interfaces";

export const screenShotState = atom<IFile>({
    key: 'screenshot',
    default: {
        base64: '',
        type: ''
    }
});


// These can be moved to a global file:
export const unitedScannerIdState = atom<string>({
    key: 'unitedScannerId',
    default: ''
});

export const unitedRegistrationState = atom<boolean>({
    key: 'unitedRegistration',
    default: false
});
